import React from "react";
import { useNavigate } from "react-router-dom";

const FreeGames = () => {
  const navigate = useNavigate();
  const handleClick = (gamesThumbnail, gamesUrl) => {
    localStorage.setItem("gameThumbnail", gamesThumbnail);
    localStorage.setItem("gameUrl", gamesUrl);
    navigate("../game-component");
  };

  const games = [
    { thumbnail: "Great_Air_Battles.webp", url: "Great Air Battles/" },
    { thumbnail: "HexGL.webp", url: "HexGL-master/" },
    { thumbnail: "Stick-Soldier.webp", url: "Stick Soldier/" },
  ];

  return (
    <div>
      <section className="game-play-section game-play-section2">
        <h1
          className="CETEGORIES"
          style={{
            fontSize: "1.5em",
            marginBottom: "60px",
            marginTop: "-60px",
          }}
        >
          FREE FOR YOU
        </h1>
        <div
          className="games-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            marginTop: "-36px",
          }}
        >
          {games.map((game, index) => (
            <div
              key={index}
              className="single-play1 action-games"
              style={{ marginBottom: "0px" }}
            >
              <div
                className="image"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "14px",
                }}
              >
                <img
                  src={`assets/Icons/${game.thumbnail}`}
                  alt="action-game-images"
                  className="zoomable-image free-images"
                  loading="lazy"
                />
              </div>
              <div
                className="play-like-action"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <a
                  className="like-button"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "18px",
                    width: "100px",
                    letterSpacing: "1px",
                  }}
                  onClick={() =>
                    handleClick(`assets/Icons/${game.thumbnail}`, game.url)
                  }
                >
                  Play
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FreeGames;
